import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Navigate } from "react-router";
import withRouter from "../.././components/withRouter";
import {postLogout} from "../../api/authApi";

const Logout = () => {
  useEffect(() => {
    postLogout();
  }, []);

  return <Navigate to="/login" />;
};

Logout.propTypes = {
  history: PropTypes.object,
};


export default withRouter(Logout);